export const bidiotvMoviesTr = [{
        id: 1,
        contents: 25,
        name: {
            tr: 'Duyulmamış Öyküler'
        },
        videos: [{
                duration: 'Watch Now',
                id: 100,
                name: '30.000 konuk ile en kalabalık doğum günü partisi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/30.000+konuk+ile+en+kalabal%C4%B1k+dog%CC%86um+gu%CC%88nu%CC%88+partisi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/30.000+konuk+ile+en+kalabal%C4%B1k+dog%CC%86um+gu%CC%88nu%CC%88+partisi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 101,
                name: 'Amsterdam\'daki karanlık geçmişini şehir turuyla siliyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Amsterdam\'daki+karanl%C4%B1k+gec%CC%A7mis%CC%A7ini+s%CC%A7ehir+turuyla+siliyor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Amsterdam\'daki+karanl%C4%B1k+gec%CC%A7mis%CC%A7ini+s%CC%A7ehir+turuyla+siliyor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 102,
                name: 'Anneden oğula büyük miras!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Anneden+og%CC%86ula+bu%CC%88yu%CC%88k+miras!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Anneden+og%CC%86ula+bu%CC%88yu%CC%88k+miras!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 103,
                name: 'Annelerden üvey annelere alışılmadık sevgi sözleri',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Annelerden+u%CC%88vey+annelere+al%C4%B1s%CC%A7%C4%B1lmad%C4%B1k+sevgi+so%CC%88zleri.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Annelerden+u%CC%88vey+annelere+al%C4%B1s%CC%A7%C4%B1lmad%C4%B1k+sevgi+so%CC%88zleri.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 104,
                name: 'Bu evde gerçek hayaletler yaşıyor!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Bu+evde+gerc%CC%A7ek+hayaletler+yas%CC%A7%C4%B1yor!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Bu+evde+gerc%CC%A7ek+hayaletler+yas%CC%A7%C4%B1yor!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 105,
                name: 'Burası aşıklar, deliler, meczuplar kahvehanesi!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Buras%C4%B1+as%CC%A7%C4%B1klar%2C+deliler%2C+meczuplar+kahvehanesi!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Buras%C4%B1+as%CC%A7%C4%B1klar%2C+deliler%2C+meczuplar+kahvehanesi!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 106,
                name: 'Çarşafla Muhabirlik Yapmak Mümkün mü?',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/C%CC%A7ars%CC%A7afla+Muhabirlik+Yapmak+Mu%CC%88mku%CC%88n+mu%CC%88%3F.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/C%CC%A7ars%CC%A7afla+Muhabirlik+Yapmak+Mu%CC%88mku%CC%88n+mu%CC%88%3F.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 107,
                name: 'Düşük maliyetli protezler umut ışığı oluyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Du%CC%88s%CC%A7u%CC%88k+maliyetli+protezler+umut+%C4%B1s%CC%A7%C4%B1g%CC%86%C4%B1+oluyor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Du%CC%88s%CC%A7u%CC%88k+maliyetli+protezler+umut+%C4%B1s%CC%A7%C4%B1g%CC%86%C4%B1+oluyor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 108,
                name: 'Erkeklerde meme kanseri daha ölümcül',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Erkeklerde+meme+kanseri+daha+o%CC%88lu%CC%88mcu%CC%88l.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Erkeklerde+meme+kanseri+daha+o%CC%88lu%CC%88mcu%CC%88l.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 109,
                name: 'Evlilik yolunda ilk adım için aşk otobüsü kalkıyor!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Evlilik+yolunda+ilk+ad%C4%B1m+ic%CC%A7in+as%CC%A7k+otobu%CC%88su%CC%88+kalk%C4%B1yor!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Evlilik+yolunda+ilk+ad%C4%B1m+ic%CC%A7in+as%CC%A7k+otobu%CC%88su%CC%88+kalk%C4%B1yor!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 110,
                name: 'Fransa\'da mülteciler için sıcak bir yuva',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Fransa\'da+mu%CC%88lteciler+ic%CC%A7in+s%C4%B1cak+bir+yuva.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Fransa\'da+mu%CC%88lteciler+ic%CC%A7in+s%C4%B1cak+bir+yuva.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 111,
                name: 'Günde 16 saat Whatsapp kullanmak ve bağımlı olmak',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Gu%CC%88nde+16+saat+Whatsapp+kullanmak+ve+bag%CC%86%C4%B1ml%C4%B1+olmak.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Gu%CC%88nde+16+saat+Whatsapp+kullanmak+ve+bag%CC%86%C4%B1ml%C4%B1+olmak.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 112,
                name: 'Köyün Sultanı İhsan Hala',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Ko%CC%88yu%CC%88n+Sultan%C4%B1+I%CC%87hsan+Hala.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Ko%CC%88yu%CC%88n+Sultan%C4%B1+I%CC%87hsan+Hala.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 113,
                name: 'Kredi kartı ile sadaka verme dönemi başlıyor!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Kredi+kart%C4%B1+ile+sadaka+verme+do%CC%88nemi+bas%CC%A7l%C4%B1yor!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Kredi+kart%C4%B1+ile+sadaka+verme+do%CC%88nemi+bas%CC%A7l%C4%B1yor!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 114,
                name: 'Kuşların şarkısına kulak ver Engellere yenilme!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Kus%CC%A7lar%C4%B1n+s%CC%A7ark%C4%B1s%C4%B1na+kulak+ver+Engellere+yenilme!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Kus%CC%A7lar%C4%B1n+s%CC%A7ark%C4%B1s%C4%B1na+kulak+ver+Engellere+yenilme!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 115,
                name: 'Kürkü için yetiştirildi Şimdi dostlarıyla emin ellerde',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Ku%CC%88rku%CC%88+ic%CC%A7in+yetis%CC%A7tirildi+S%CC%A7imdi+dostlar%C4%B1yla+emin+ellerde.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Ku%CC%88rku%CC%88+ic%CC%A7in+yetis%CC%A7tirildi+S%CC%A7imdi+dostlar%C4%B1yla+emin+ellerde.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 116,
                name: 'Kızı Işid\'e katılan anne \'Umudumu yitirmeyeceğim\'',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/K%C4%B1z%C4%B1+Is%CC%A7id\'e+kat%C4%B1lan+anne+\'Umudumu+yitirmeyeceg%CC%86im\'.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/K%C4%B1z%C4%B1+Is%CC%A7id\'e+kat%C4%B1lan+anne+\'Umudumu+yitirmeyeceg%CC%86im\'.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 117,
                name: 'Lübnanlı kadınlar ayaklandı Tecavüz yasasına hayır',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Lu%CC%88bnanl%C4%B1+kad%C4%B1nlar+ayakland%C4%B1+Tecavu%CC%88z+yasas%C4%B1na+hay%C4%B1r.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Lu%CC%88bnanl%C4%B1+kad%C4%B1nlar+ayakland%C4%B1+Tecavu%CC%88z+yasas%C4%B1na+hay%C4%B1r.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 118,
                name: 'Menbiç artık özgür. Kadınlar görev başında!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Menbic%CC%A7+art%C4%B1k+o%CC%88zgu%CC%88r.+Kad%C4%B1nlar+go%CC%88rev+bas%CC%A7%C4%B1nda!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Menbic%CC%A7+art%C4%B1k+o%CC%88zgu%CC%88r.+Kad%C4%B1nlar+go%CC%88rev+bas%CC%A7%C4%B1nda!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 119,
                name: 'Mültecilerin Siyahi Meleği İzmirli Mandela',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Mu%CC%88ltecilerin+Siyahi+Meleg%CC%86i+I%CC%87zmirli+Mandela.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Mu%CC%88ltecilerin+Siyahi+Meleg%CC%86i+I%CC%87zmirli+Mandela.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 120,
                name: 'Mısır\'daki bu köyde 500 tane ikiz olması tesadüf mü?',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/M%C4%B1s%C4%B1r\'daki+bu+ko%CC%88yde+500+tane+ikiz+olmas%C4%B1+tesadu%CC%88f+mu%CC%88%3F.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/M%C4%B1s%C4%B1r\'daki+bu+ko%CC%88yde+500+tane+ikiz+olmas%C4%B1+tesadu%CC%88f+mu%CC%88%3F.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 121,
                name: 'Sanatıyla hayat buldu Renklerle dans ederek 104 sene',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Sanat%C4%B1yla+hayat+buldu+Renklerle+dans+ederek+104+sene.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Sanat%C4%B1yla+hayat+buldu+Renklerle+dans+ederek+104+sene.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 122,
                name: 'Sevgililer buluşuyor İlk aşklar Planetaryum\'da başlar',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Sevgililer+bulus%CC%A7uyor+I%CC%87lk+as%CC%A7klar+Planetaryum\'da+bas%CC%A7lar.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Sevgililer+bulus%CC%A7uyor+I%CC%87lk+as%CC%A7klar+Planetaryum\'da+bas%CC%A7lar.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 123,
                name: 'Sevimli dostlara özel kostüm Bir zırh için 200 saat',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Sevimli+dostlara+o%CC%88zel+kostu%CC%88m+Bir+z%C4%B1rh+ic%CC%A7in+200+saat.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/Sevimli+dostlara+o%CC%88zel+kostu%CC%88m+Bir+z%C4%B1rh+ic%CC%A7in+200+saat.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 124,
                name: 'St. Petersburg sokaklarında gizlenen bebek figürleri',
                videoUrl: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/St.+Petersburg+sokaklar%C4%B1nda+gizlenen+bebek+figu%CC%88rleri.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Duyulmamis+Oykuler/St.+Petersburg+sokaklar%C4%B1nda+gizlenen+bebek+figu%CC%88rleri.jpg',
                filename: ''
            }
        ]
    },
    {
        id: 21,
        contents: 3,
        name: {
            tr: 'Crypto',
            en: 'Crypto'
        },
        videos: [
            {
                duration: 'Watch Now',
                id: 210,
                name: '1 HAFTADA NASIL 8000TL KAZANDIM - KRİPTO PARA AL-SAT YAPARAK PARA KAZANMAK',
                videoUrl: 'https://cdn.mobiotv.com/tr/Crypto/1+HAFTADA+NASIL+8000TL+KAZANDIM+-+KRI%CC%87PTO+PARA+AL-SAT+YAPARAK+PARA+KAZANMAK.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Crypto/1+HAFTADA+NASIL+8000TL+KAZANDIM+-+KRI%CC%87PTO+PARA+AL-SAT+YAPARAK+PARA+KAZANMAK.jpeg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 211,
                name: '5.000TL\'yi 40.000TL YAPMAK! BİTCOİN İLE ZENGİN OLMAK! @Coin Muhendisi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Crypto/5.000TL\'yi+40.000TL+YAPMAK!+BI%CC%87TCOI%CC%87N+I%CC%87LE+ZENGI%CC%87N+OLMAK!+%40Coin+Muhendisi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Crypto/5.000TL\'yi+40.000TL+YAPMAK!+BI%CC%87TCOI%CC%87N+I%CC%87LE+ZENGI%CC%87N+OLMAK!+%40Coin+Muhendisi.jpeg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 212,
                name: 'Bunları bilmeden Kripto Para sektörüne girme!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Crypto/Bunlar%C4%B1+bilmeden+Kripto+Para+sekto%CC%88ru%CC%88ne+girme!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Crypto/Bunlar%C4%B1+bilmeden+Kripto+Para+sekto%CC%88ru%CC%88ne+girme!.jpeg',
                filename: ''
            }
        ]
    },
    {
        id: 2,
        contents: 26,
        name: {
            tr: 'İlginç'
        },
        videos: [{
                duration: 'Watch Now',
                id: 125,
                name: '2016, LGBT\'ler için altın yıl oldu',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/2016%2C+LGBT\'ler+ic%CC%A7in+alt%C4%B1n+y%C4%B1l+oldu.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/2016%2C+LGBT\'ler+ic%CC%A7in+alt%C4%B1n+y%C4%B1l+oldu.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 126,
                name: 'Akıllı köpek Kitsu\'nun yuvarlanma çabası',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Ak%C4%B1ll%C4%B1+ko%CC%88pek+Kitsu\'nun+yuvarlanma+c%CC%A7abas%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Ak%C4%B1ll%C4%B1+ko%CC%88pek+Kitsu\'nun+yuvarlanma+c%CC%A7abas%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 127,
                name: 'Amsterdam\'da soyundular Vücudunla barış, fiziğini sev!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Amsterdam\'da+soyundular+Vu%CC%88cudunla+bar%C4%B1s%CC%A7%2C+fizig%CC%86ini+sev!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Amsterdam\'da+soyundular+Vu%CC%88cudunla+bar%C4%B1s%CC%A7%2C+fizig%CC%86ini+sev!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 128,
                name: 'Beslediği yılanla hava atmaya çalışti ve ısırıldı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Besledig%CC%86i+y%C4%B1lanla+hava+atmaya+c%CC%A7al%C4%B1s%CC%A7ti+ve+%C4%B1s%C4%B1r%C4%B1ld%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Besledig%CC%86i+y%C4%B1lanla+hava+atmaya+c%CC%A7al%C4%B1s%CC%A7ti+ve+%C4%B1s%C4%B1r%C4%B1ld%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 129,
                name: 'Buzda kaymak hiç bu kadar eğlenceli olmamıştı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Buzda+kaymak+hic%CC%A7+bu+kadar+eg%CC%86lenceli+olmam%C4%B1s%CC%A7t%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Buzda+kaymak+hic%CC%A7+bu+kadar+eg%CC%86lenceli+olmam%C4%B1s%CC%A7t%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 130,
                name: 'Fikriniz havada kalmasın, duvara yazın',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Fikriniz+havada+kalmas%C4%B1n%2C+duvara+yaz%C4%B1n.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Fikriniz+havada+kalmas%C4%B1n%2C+duvara+yaz%C4%B1n.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 131,
                name: 'Hayvanseverler ayaklandı Zavallı ayılar açlık çekiyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Hayvanseverler+ayakland%C4%B1+Zavall%C4%B1+ay%C4%B1lar+ac%CC%A7l%C4%B1k+c%CC%A7ekiyor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Hayvanseverler+ayakland%C4%B1+Zavall%C4%B1+ay%C4%B1lar+ac%CC%A7l%C4%B1k+c%CC%A7ekiyor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 132,
                name: 'İnstagramda adrenalin ateşi Lavların içinde show yaptı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/I%CC%87nstagramda+adrenalin+ates%CC%A7i+Lavlar%C4%B1n+ic%CC%A7inde+show+yapt%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/I%CC%87nstagramda+adrenalin+ates%CC%A7i+Lavlar%C4%B1n+ic%CC%A7inde+show+yapt%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 133,
                name: 'İspanya mutfağından efsane lezzet Cocido!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/I%CC%87spanya+mutfag%CC%86%C4%B1ndan+efsane+lezzet+Cocido!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/I%CC%87spanya+mutfag%CC%86%C4%B1ndan+efsane+lezzet+Cocido!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 134,
                name: 'İtalya\'da noel ağacı bu yıl bir başka parlıyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/I%CC%87talya\'da+noel+ag%CC%86ac%C4%B1+bu+y%C4%B1l+bir+bas%CC%A7ka+parl%C4%B1yor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/I%CC%87talya\'da+noel+ag%CC%86ac%C4%B1+bu+y%C4%B1l+bir+bas%CC%A7ka+parl%C4%B1yor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 135,
                name: 'Komik köpek Sahibine böyle kızdı',
                videoUrl: '',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Komik+ko%CC%88pek+Sahibine+bo%CC%88yle+k%C4%B1zd%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 136,
                name: 'Küçük alanlarda harikalar yaratmak Mini ev projesi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Ku%CC%88c%CC%A7u%CC%88k+alanlarda+harikalar+yaratmak+Mini+ev+projesi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Ku%CC%88c%CC%A7u%CC%88k+alanlarda+harikalar+yaratmak+Mini+ev+projesi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 137,
                name: 'Moskova metrosunda karşı hatta uçarak geçiş',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Moskova+metrosunda+kars%CC%A7%C4%B1+hatta+uc%CC%A7arak+gec%CC%A7is%CC%A7.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Moskova+metrosunda+kars%CC%A7%C4%B1+hatta+uc%CC%A7arak+gec%CC%A7is%CC%A7.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 138,
                name: 'Nama, 11 çocuk annesi ve 23 yaşında!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Nama%2C+11+c%CC%A7ocuk+annesi+ve+23+yas%CC%A7%C4%B1nda!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Nama%2C+11+c%CC%A7ocuk+annesi+ve+23+yas%CC%A7%C4%B1nda!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 139,
                name: 'Nefesli çalgılarda yeni icat Burundan üflemeliler',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Nefesli+c%CC%A7alg%C4%B1larda+yeni+icat+Burundan+u%CC%88flemeliler.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Nefesli+c%CC%A7alg%C4%B1larda+yeni+icat+Burundan+u%CC%88flemeliler.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 140,
                name: 'Okyanus derinliklerindeki muhteşem dünya',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Okyanus+derinliklerindeki+muhtes%CC%A7em+du%CC%88nya.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Okyanus+derinliklerindeki+muhtes%CC%A7em+du%CC%88nya.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 141,
                name: 'Sahibi ile aynı tuvaleti kullanan akıllı köpek',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Sahibi+ile+ayn%C4%B1+tuvaleti+kullanan+ak%C4%B1ll%C4%B1+ko%CC%88pek.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Sahibi+ile+ayn%C4%B1+tuvaleti+kullanan+ak%C4%B1ll%C4%B1+ko%CC%88pek.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 142,
                name: 'Sevimli Malezyalılar kahkahaya boğuldular',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Sevimli+Malezyal%C4%B1lar+kahkahaya+bog%CC%86uldular.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Sevimli+Malezyal%C4%B1lar+kahkahaya+bog%CC%86uldular.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 143,
                name: 'Siber Saldırı altında olabilirsiniz!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Siber+Sald%C4%B1r%C4%B1+alt%C4%B1nda+olabilirsiniz!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Siber+Sald%C4%B1r%C4%B1+alt%C4%B1nda+olabilirsiniz!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 144,
                name: 'St. Petersburg sokaklarında gizlenen bebek figürleri',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/St.+Petersburg+sokaklar%C4%B1nda+gizlenen+bebek+figu%CC%88rleri.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/St.+Petersburg+sokaklar%C4%B1nda+gizlenen+bebek+figu%CC%88rleri.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 145,
                name: 'Tanışabileceğiniz en zeki down sendromlu kişi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Tan%C4%B1s%CC%A7abileceg%CC%86iniz+en+zeki+down+sendromlu+kis%CC%A7i.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Tan%C4%B1s%CC%A7abileceg%CC%86iniz+en+zeki+down+sendromlu+kis%CC%A7i.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 146,
                name: 'Tek bacakla müthiş performans BMX yıldızı büyülüyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Tek+bacakla+mu%CC%88this%CC%A7+performans+BMX+y%C4%B1ld%C4%B1z%C4%B1+bu%CC%88yu%CC%88lu%CC%88yor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Tek+bacakla+mu%CC%88this%CC%A7+performans+BMX+y%C4%B1ld%C4%B1z%C4%B1+bu%CC%88yu%CC%88lu%CC%88yor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 147,
                name: 'Tüy yumağı bu şirin köpek için egzersiz zamanı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Tu%CC%88y+yumag%CC%86%C4%B1+bu+s%CC%A7irin+ko%CC%88pek+ic%CC%A7in+egzersiz+zaman%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Tu%CC%88y+yumag%CC%86%C4%B1+bu+s%CC%A7irin+ko%CC%88pek+ic%CC%A7in+egzersiz+zaman%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 148,
                name: 'Virjinya\'daki usta yüzücülerden buzda yüzme teknikleri',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Virjinya\'daki+usta+yu%CC%88zu%CC%88cu%CC%88lerden+buzda+yu%CC%88zme+teknikleri.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Virjinya\'daki+usta+yu%CC%88zu%CC%88cu%CC%88lerden+buzda+yu%CC%88zme+teknikleri.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 149,
                name: 'Yaramaz bebek gergedanın keyifli dakikaları',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Yaramaz+bebek+gergedan%C4%B1n+keyifli+dakikalar%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Yaramaz+bebek+gergedan%C4%B1n+keyifli+dakikalar%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 150,
                name: 'Yürekleri ağza getiren kazadan şans eseri kurtuldular',
                videoUrl: 'https://cdn.mobiotv.com/tr/Ilginc/Yu%CC%88rekleri+ag%CC%86za+getiren+kazadan+s%CC%A7ans+eseri+kurtuldular.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Ilginc/Yu%CC%88rekleri+ag%CC%86za+getiren+kazadan+s%CC%A7ans+eseri+kurtuldular.jpg',
                filename: ''
            }
        ]
    },
    {
        id: 3,
        contents: 23,
        name: {
            tr: 'Ünlüler'
        },
        videos: [{
                duration: 'Watch Now',
                id: 151,
                name: 'Adele 5 ödülle Grammy gecesine damgasını vurdu',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Adele+5+o%CC%88du%CC%88lle+Grammy+gecesine+damgas%C4%B1n%C4%B1+vurdu.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Adele+5+o%CC%88du%CC%88lle+Grammy+gecesine+damgas%C4%B1n%C4%B1+vurdu.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 152,
                name: 'Angelina Jolie ilk kez konuştu \'Biz bir aileyiz\'',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Angelina+Jolie+ilk+kez+konus%CC%A7tu+\'Biz+bir+aileyiz\'.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Angelina+Jolie+ilk+kez+konus%CC%A7tu+\'Biz+bir+aileyiz\'.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 153,
                name: 'Angelina Jolie\'nin formda olmasının sırrı Böcekler!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Angelina+Jolie\'nin+formda+olmas%C4%B1n%C4%B1n+s%C4%B1rr%C4%B1+Bo%CC%88cekler!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Angelina+Jolie\'nin+formda+olmas%C4%B1n%C4%B1n+s%C4%B1rr%C4%B1+Bo%CC%88cekler!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 154,
                name: 'Angelina\'ya kızının biyolojik annesinden duygusal talep',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Angelina\'ya+k%C4%B1z%C4%B1n%C4%B1n+biyolojik+annesinden+duygusal+talep.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Angelina\'ya+k%C4%B1z%C4%B1n%C4%B1n+biyolojik+annesinden+duygusal+talep.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 155,
                name: 'Chrissy Teigen doğum sonrası depresyonda yalnız değil',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Chrissy+Teigen+dog%CC%86um+sonras%C4%B1+depresyonda+yaln%C4%B1z+deg%CC%86il.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Chrissy+Teigen+dog%CC%86um+sonras%C4%B1+depresyonda+yaln%C4%B1z+deg%CC%86il.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 156,
                name: 'Coachella 2017\'de dev isim Beyonce yerine Gaga geliyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Coachella+2017\'de+dev+isim+Beyonce+yerine+Gaga+geliyor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Coachella+2017\'de+dev+isim+Beyonce+yerine+Gaga+geliyor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 157,
                name: 'David Beckham\'ın dövmelerinin ardındaki sır çözüldü',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/David+Beckham\'%C4%B1n+do%CC%88vmelerinin+ard%C4%B1ndaki+s%C4%B1r+c%CC%A7o%CC%88zu%CC%88ldu%CC%88.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/David+Beckham\'%C4%B1n+do%CC%88vmelerinin+ard%C4%B1ndaki+s%C4%B1r+c%CC%A7o%CC%88zu%CC%88ldu%CC%88.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 158,
                name: 'Devir tasarruf devri Paranın kıymetini bilen ünlüler',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Devir+tasarruf+devri+Paran%C4%B1n+k%C4%B1ymetini+bilen+u%CC%88nlu%CC%88ler.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Devir+tasarruf+devri+Paran%C4%B1n+k%C4%B1ymetini+bilen+u%CC%88nlu%CC%88ler.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 159,
                name: 'Ed Sheeran hayranları şokta Genç yıldız oyuncu oluyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Ed+Sheeran+hayranlar%C4%B1+s%CC%A7okta+Genc%CC%A7+y%C4%B1ld%C4%B1z+oyuncu+oluyor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Ed+Sheeran+hayranlar%C4%B1+s%CC%A7okta+Genc%CC%A7+y%C4%B1ld%C4%B1z+oyuncu+oluyor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 160,
                name: 'Futbol ve matematik İki dünya birbiri ile çarpışıyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Futbol+ve+matematik+I%CC%87ki+du%CC%88nya+birbiri+ile+c%CC%A7arp%C4%B1s%CC%A7%C4%B1yor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Futbol+ve+matematik+I%CC%87ki+du%CC%88nya+birbiri+ile+c%CC%A7arp%C4%B1s%CC%A7%C4%B1yor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 161,
                name: 'Game Of Thrones ekibi Sevilla-Barcelona maçını izledi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Game+Of+Thrones+ekibi+Sevilla-Barcelona+mac%CC%A7%C4%B1n%C4%B1+izledi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Game+Of+Thrones+ekibi+Sevilla-Barcelona+mac%CC%A7%C4%B1n%C4%B1+izledi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 162,
                name: 'Gigi Hadid moda ve geleneksel değerleri birleştirdi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Gigi+Hadid+moda+ve+geleneksel+deg%CC%86erleri+birles%CC%A7tirdi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Gigi+Hadid+moda+ve+geleneksel+deg%CC%86erleri+birles%CC%A7tirdi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 163,
                name: 'Henüz 30 yaşına gelmeden kazanılan büyük servet!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Henu%CC%88z+30+yas%CC%A7%C4%B1na+gelmeden+kazan%C4%B1lan+bu%CC%88yu%CC%88k+servet!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Henu%CC%88z+30+yas%CC%A7%C4%B1na+gelmeden+kazan%C4%B1lan+bu%CC%88yu%CC%88k+servet!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 164,
                name: 'İstanbul Kırmızısı’nın İtalya tanıtımı yapıldı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/I%CC%87stanbul+K%C4%B1rm%C4%B1z%C4%B1s%C4%B1%E2%80%99n%C4%B1n+I%CC%87talya+tan%C4%B1t%C4%B1m%C4%B1+yap%C4%B1ld%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/I%CC%87stanbul+K%C4%B1rm%C4%B1z%C4%B1s%C4%B1%E2%80%99n%C4%B1n+I%CC%87talya+tan%C4%B1t%C4%B1m%C4%B1+yap%C4%B1ld%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 165,
                name: 'Justin Bieber\'ın selfie isteyen hayranlara tepkisi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Justin+Bieber\'%C4%B1n+selfie+isteyen+hayranlara+tepkisi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Justin+Bieber\'%C4%B1n+selfie+isteyen+hayranlara+tepkisi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 166,
                name: 'Justin Timberlake yılın ablümünü seçti \'Blonde\'',
                videoUrl: '',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Justin+Timberlake+y%C4%B1l%C4%B1n+ablu%CC%88mu%CC%88nu%CC%88+sec%CC%A7ti+\'Blonde\'.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 167,
                name: 'Kylie Minogue Yeni aldatma skandalı!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Kylie+Minogue+Yeni+aldatma+skandal%C4%B1!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Kylie+Minogue+Yeni+aldatma+skandal%C4%B1!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 168,
                name: 'Mutlu haber Matt Damon\'ı neredeyse göz yaşlarına boğdu',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Mutlu+haber+Matt+Damon\'%C4%B1+neredeyse+go%CC%88z+yas%CC%A7lar%C4%B1na+bog%CC%86du.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Mutlu+haber+Matt+Damon\'%C4%B1+neredeyse+go%CC%88z+yas%CC%A7lar%C4%B1na+bog%CC%86du.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 169,
                name: 'Nicole Kidman \'Lenny Kravitz eski nişanlımdı\'',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Nicole+Kidman+\'Lenny+Kravitz+eski+nis%CC%A7anl%C4%B1md%C4%B1\'.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Nicole+Kidman+\'Lenny+Kravitz+eski+nis%CC%A7anl%C4%B1md%C4%B1\'.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 170,
                name: 'Selena Gomez ve The Weeknd aşkı için büyük iddia',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Selena+Gomez+ve+The+Weeknd+as%CC%A7k%C4%B1+ic%CC%A7in+bu%CC%88yu%CC%88k+iddia.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Selena+Gomez+ve+The+Weeknd+as%CC%A7k%C4%B1+ic%CC%A7in+bu%CC%88yu%CC%88k+iddia.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 171,
                name: 'Taylor Swift protestoya katılmadı hayranları ayaklandı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Taylor+Swift+protestoya+kat%C4%B1lmad%C4%B1+hayranlar%C4%B1+ayakland%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Taylor+Swift+protestoya+kat%C4%B1lmad%C4%B1+hayranlar%C4%B1+ayakland%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 172,
                name: 'Taylor Swift’ten yeni albüm',
                videoUrl: 'https://cdn.mobiotv.com/tr/Unluler/Taylor+Swift%E2%80%99ten+yeni+albu%CC%88m.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Taylor+Swift%E2%80%99ten+yeni+albu%CC%88m.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 173,
                name: 'Yılların eskitemediği güzellik Helen Mirren büyüledi',
                videoUrl: '',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Unluler/Y%C4%B1llar%C4%B1n+eskitemedig%CC%86i+gu%CC%88zellik+Helen+Mirren+bu%CC%88yu%CC%88ledi.jpg',
                filename: ''
            }
        ]
    },
    {
        id: 4,
        contents: 26,
        name: {
            tr: 'Yaşam'
        },
        videos: [{
                duration: 'Watch Now',
                id: 174,
                name: 'Dev Salıncak\' ile adrenalin ve görsel şölen',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/\'Dev+Sal%C4%B1ncak\'+ile+adrenalin+ve+go%CC%88rsel+s%CC%A7o%CC%88len.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/\'Dev+Sal%C4%B1ncak\'+ile+adrenalin+ve+go%CC%88rsel+s%CC%A7o%CC%88len.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 175,
                name: '60 Saniyede sağlıklı beslen Nohut Salata',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/60+Saniyede+sag%CC%86l%C4%B1kl%C4%B1+beslen+Nohut+Salata.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/60+Saniyede+sag%CC%86l%C4%B1kl%C4%B1+beslen+Nohut+Salata.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 176,
                name: '60 Saniyede sağlıklı beslen Patlıcan pizza',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/60+Saniyede+sag%CC%86l%C4%B1kl%C4%B1+beslen+Patl%C4%B1can+pizza.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/60+Saniyede+sag%CC%86l%C4%B1kl%C4%B1+beslen+Patl%C4%B1can+pizza.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 177,
                name: '60 Saniyede sağlıklı bir hayata adım at Tavuk Salatası',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/60+Saniyede+sag%CC%86l%C4%B1kl%C4%B1+bir+hayata+ad%C4%B1m+at+Tavuk+Salatas%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/60+Saniyede+sag%CC%86l%C4%B1kl%C4%B1+bir+hayata+ad%C4%B1m+at+Tavuk+Salatas%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 178,
                name: 'ABD\'de kadın olmak zor Doğum izni alana para yok!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/ABD\'de+kad%C4%B1n+olmak+zor+Dog%CC%86um+izni+alana+para+yok!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/ABD\'de+kad%C4%B1n+olmak+zor+Dog%CC%86um+izni+alana+para+yok!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 179,
                name: 'Almanya\'daki organik çiftlikte keçiler işkence görüyor',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Almanya\'daki+organik+c%CC%A7iftlikte+kec%CC%A7iler+is%CC%A7kence+go%CC%88ru%CC%88yor.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Almanya\'daki+organik+c%CC%A7iftlikte+kec%CC%A7iler+is%CC%A7kence+go%CC%88ru%CC%88yor.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 180,
                name: 'Avokado Maskesi Nasıl Yapılır?',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Avokado+Maskesi+Nas%C4%B1l+Yap%C4%B1l%C4%B1r%3F.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Avokado+Maskesi+Nas%C4%B1l+Yap%C4%B1l%C4%B1r%3F.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 181,
                name: 'Batılı ülkelerdeki müslüman nüfusu, düşünülenin altında',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Bat%C4%B1l%C4%B1+u%CC%88lkelerdeki+mu%CC%88slu%CC%88man+nu%CC%88fusu%2C+du%CC%88s%CC%A7u%CC%88nu%CC%88lenin+alt%C4%B1nda.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Bat%C4%B1l%C4%B1+u%CC%88lkelerdeki+mu%CC%88slu%CC%88man+nu%CC%88fusu%2C+du%CC%88s%CC%A7u%CC%88nu%CC%88lenin+alt%C4%B1nda.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 182,
                name: 'Çin\'den iyi haber geldi Hayvanlar artık güvende olacak',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/C%CC%A7in\'den+iyi+haber+geldi+Hayvanlar+art%C4%B1k+gu%CC%88vende+olacak.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/C%CC%A7in\'den+iyi+haber+geldi+Hayvanlar+art%C4%B1k+gu%CC%88vende+olacak.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 183,
                name: 'Çılgınlar gibi kovalamaca oynamak',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/C%CC%A7ocuk+yogas%C4%B1yla+tan%C4%B1s%CC%A7%C4%B1n+C%CC%A7ark+Durus%CC%A7u.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/C%CC%A7ocuk+yogas%C4%B1yla+tan%C4%B1s%CC%A7%C4%B1n+C%CC%A7ark+Durus%CC%A7u.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 184,
                name: 'Çocuk yogasıyla tanışın Çark Duruşu',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/C%CC%A7%C4%B1lg%C4%B1nlar+gibi+kovalamaca+oynamak.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/C%CC%A7%C4%B1lg%C4%B1nlar+gibi+kovalamaca+oynamak.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 185,
                name: 'Dağ bisikleti ile engellere ve meydan okudu',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Dag%CC%86+bisikleti+ile+engellere+ve+meydan+okudu.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Dag%CC%86+bisikleti+ile+engellere+ve+meydan+okudu.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 186,
                name: 'Doğal Sakal ve Bıyık Bakımı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Dog%CC%86al+Sakal+ve+B%C4%B1y%C4%B1k+Bak%C4%B1m%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Dog%CC%86al+Sakal+ve+B%C4%B1y%C4%B1k+Bak%C4%B1m%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 187,
                name: 'Hayata yelken aç Dünyanın en zor solo yarısı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Hayata+yelken+ac%CC%A7+Du%CC%88nyan%C4%B1n+en+zor+solo+yar%C4%B1s%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Hayata+yelken+ac%CC%A7+Du%CC%88nyan%C4%B1n+en+zor+solo+yar%C4%B1s%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 188,
                name: 'Hayatına renk ver Japonların Makyaj Tarzı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Hayat%C4%B1na+renk+ver+Japonlar%C4%B1n+Makyaj+Tarz%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Hayat%C4%B1na+renk+ver+Japonlar%C4%B1n+Makyaj+Tarz%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 189,
                name: 'Hayatına renk ver Renkli saç spreyi nasıl kullanılır?',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Hayat%C4%B1na+renk+ver+Renkli+sac%CC%A7+spreyi+nas%C4%B1l+kullan%C4%B1l%C4%B1r%3F.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Hayat%C4%B1na+renk+ver+Renkli+sac%CC%A7+spreyi+nas%C4%B1l+kullan%C4%B1l%C4%B1r%3F.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 190,
                name: 'Hollanda’da Öğrenciler ketenden otomobil yaptı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Hollanda%E2%80%99da+O%CC%88g%CC%86renciler+ketenden+otomobil+yapt%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Hollanda%E2%80%99da+O%CC%88g%CC%86renciler+ketenden+otomobil+yapt%C4%B1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 191,
                name: 'İçinizi ısıtacak Yavru filin havuz keyfi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/I%CC%87c%CC%A7inizi+%C4%B1s%C4%B1tacak+Yavru+filin+havuz+keyfi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/I%CC%87c%CC%A7inizi+%C4%B1s%C4%B1tacak+Yavru+filin+havuz+keyfi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 192,
                name: 'İstanbul-New York arası 24 dakikaya düşecek',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/I%CC%87stanbul-New+York+aras%C4%B1+24+dakikaya+du%CC%88s%CC%A7ecek.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/I%CC%87stanbul-New+York+aras%C4%B1+24+dakikaya+du%CC%88s%CC%A7ecek.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 193,
                name: 'Muz maskesi ile cildiniz ışık saçsın',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Muz+maskesi+ile+cildiniz+%C4%B1s%CC%A7%C4%B1k+sac%CC%A7s%C4%B1n.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Muz+maskesi+ile+cildiniz+%C4%B1s%CC%A7%C4%B1k+sac%CC%A7s%C4%B1n.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 194,
                name: 'Saçlarınla festivallerde fark yarat 1',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Sac%CC%A7lar%C4%B1nla+festivallerde+fark+yarat+1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Sac%CC%A7lar%C4%B1nla+festivallerde+fark+yarat+1.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 195,
                name: 'Saçlarınla festivallerde fark yarat',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Sac%CC%A7lar%C4%B1nla+festivallerde+fark+yarat.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Sac%CC%A7lar%C4%B1nla+festivallerde+fark+yarat.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 196,
                name: 'Sağlıklı olmak için vücudumuzun sesine kulak verelim',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Sag%CC%86l%C4%B1kl%C4%B1+olmak+ic%CC%A7in+vu%CC%88cudumuzun+sesine+kulak+verelim.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Sag%CC%86l%C4%B1kl%C4%B1+olmak+ic%CC%A7in+vu%CC%88cudumuzun+sesine+kulak+verelim.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 197,
                name: 'Sevgililer gününe yalnız girmek istemeyenler buraya!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Sevgililer+gu%CC%88nu%CC%88ne+yaln%C4%B1z+girmek+istemeyenler+buraya!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Sevgililer+gu%CC%88nu%CC%88ne+yaln%C4%B1z+girmek+istemeyenler+buraya!.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 198,
                name: 'Yaban Mersini Yüz Maskesi',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Yaban+Mersini+Yu%CC%88z+Maskesi.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Yaban+Mersini+Yu%CC%88z+Maskesi.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 199,
                name: 'Yavru köpek görünce ilk yaptığımız Bebek konuşması',
                videoUrl: 'https://cdn.mobiotv.com/tr/Yasam/Yavru+ko%CC%88pek+go%CC%88ru%CC%88nce+ilk+yapt%C4%B1g%CC%86%C4%B1m%C4%B1z+Bebek+konus%CC%A7mas%C4%B1.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Yasam/Yavru+ko%CC%88pek+go%CC%88ru%CC%88nce+ilk+yapt%C4%B1g%CC%86%C4%B1m%C4%B1z+Bebek+konus%CC%A7mas%C4%B1.jpg',
                filename: ''
            }
        ]
    },
    {
        id: 5,
        contents: 26,
        name: {
            tr: 'Telefon Koruması'
        },
        videos: [{
                duration: 'Watch Now',
                id: 200,
                name: 'Android cihazınızı virüslerden nasıl korursunuz',
                videoUrl: 'https://cdn.mobiotv.com/tr/Phone+Protection/How+to+protect+your+Android+device+from+viruses.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Phone+Protection/How+to+protect+your+Android+device+from+viruses.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 201,
                name: 'Herhangi Bir Android Cihazda Virüs Nasıl Kaldırılır ve Hataları Nasıl Giderilir (2020 ÇALIŞIYOR)',
                videoUrl: 'https://cdn.mobiotv.com/tr/Phone+Protection/How+To+Remove+Virus+%26+Fix+Errors+On+Any+Android+Device(2020+WORKS).mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Phone+Protection/How+To+Remove+Virus+%26+Fix+Errors+On+Any+Android+Device(2020+WORKS).jpeg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 202,
                name: 'iPhone Virüsleri - Onlardan Nasıl Kurtulunur!',
                videoUrl: 'https://cdn.mobiotv.com/tr/Phone+Protection/iPhone+Viruses+-+How+To+Get+Rid+Of+Them!.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Phone+Protection/iPhone+Viruses+-+How+To+Get+Rid+Of+Them!.jpeg',
                filename: ''
            },
            
        ]
    },
    {
        id: 6,
        contents: 3,
        name: {
            tr: 'Fall Guys İpuçları ve Püf Noktaları'
        },
        videos: [{
                duration: 'Watch Now',
                id: 203,
                name: 'Fall Guys - Nihai Kılavuz - Her Tur Nasıl Kazanılır',
                videoUrl: 'https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 204,
                name: 'Fall Guys Ultimate İpuçları ve Püf Noktaları',
                videoUrl: 'https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 205,
                name: 'Fall Guys - Her Seviye Nasıl Kazanılır?',
                videoUrl: 'https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.jpg',
                filename: ''
            },
            
        ]
    },
    {
        id: 7,
        contents: 3,
        name: {
            tr: 'ABS'
        },
        videos: [{
                duration: 'Watch Now',
                id: 300,
                name: 'Plank (Low)',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/1+Plank+(Low).mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/1+Plank+(Low).jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 301,
                name: 'High Plank',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/15+High+Plank.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/15+High+Plank.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 302,
                name: 'Side Plank Crunches',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/2+Side+Plank+Crunches.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/2+Side+Plank+Crunches.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 303,
                name: 'Boat V-Sit',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/21+Boat+V-Sit.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/21+Boat+V-Sit.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 304,
                name: 'Shoulder Taps',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/3+Shoulder+Taps.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/3+Shoulder+Taps.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 305,
                name: 'Plank Hip Dips',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/31+Plank+Hip+Dips.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/31+Plank+Hip+Dips.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 306,
                name: 'Mountain Climbers',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/4+Mountain+Climbers.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/4+Mountain+Climbers.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 308,
                name: 'Crunches',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/5+Crunches.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/5+Crunches.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 309,
                name: 'Reverse Crunches',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/6+Reverse+Crunches.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/6+Reverse+Crunches.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 310,
                name: 'Bicycle Crunches',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/7+Bicycle+Crunches.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/7+Bicycle+Crunches.jpg',
                filename: ''
            },
            
        ]
    },
    {
        id: 8,
        contents: 3,
        name: {
            tr: 'Back'
        },
        videos: [{
                duration: 'Watch Now',
                id: 400,
                name: 'Back extensions',
                videoUrl: 'https://cdn.mobiotv.com/tr/Back/Back+extensions.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Back/Back+extensions.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 401,
                name: 'Body weight prone military press',
                videoUrl: 'https://cdn.mobiotv.com/tr/Back/Body+weight+prone+military+press.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Back/Body+weight+prone+military+press.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 402,
                name: 'Body weight wall slides',
                videoUrl: 'https://cdn.mobiotv.com/tr/Back/Body+weight+wall+slides.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Back/Body+weight+wall+slides.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 403,
                name: 'Boat V-Sit',
                videoUrl: 'https://cdn.mobiotv.com/tr/ABS/21+Boat+V-Sit.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/ABS/21+Boat+V-Sit.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 404,
                name: 'Floor Y raise',
                videoUrl: 'https://cdn.mobiotv.com/tr/Back/Floor+Y+raise.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Back/Floor+Y+raise.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 405,
                name: 'Pilates Swimming',
                videoUrl: 'https://cdn.mobiotv.com/tr/Back/Pilates+Swimming.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Back/Pilates+Swimming.jpg',
                filename: ''
            },
        ]
    },
    {
        id: 9,
        contents: 3,
        name: {
            tr: 'Biceps'
        },
        videos: [{
                duration: 'Watch Now',
                id: 500,
                name: 'Bent over row',
                videoUrl: 'https://cdn.mobiotv.com/tr/Biceps/Bent+over+row.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Biceps/Bent+over+row.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 501,
                name: 'Pull apart',
                videoUrl: 'https://cdn.mobiotv.com/tr/Biceps/Pull+apart.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Biceps/Pull+apart.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 502,
                name: 'Standing 1-arm high bicep curl',
                videoUrl: 'https://cdn.mobiotv.com/tr/Biceps/Standing+1-arm+high+bicep+curl.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Biceps/Standing+1-arm+high+bicep+curl.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 503,
                name: 'Standing 1-arm low bicep curl',
                videoUrl: 'https://cdn.mobiotv.com/tr/Biceps/Standing+1-arm+low+bicep+curl.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Biceps/Standing+1-arm+low+bicep+curl.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 504,
                name: 'Tall-kneeling 1-arm pull-in',
                videoUrl: 'https://cdn.mobiotv.com/tr/Biceps/Tall-kneeling+1-arm+pull-in.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Biceps/Tall-kneeling+1-arm+pull-in.jpg',
                filename: ''
            },
        ]
    },
    {
        id: 10,
        contents: 3,
        name: {
            tr: 'Glutes'
        },
        videos: [{
                duration: 'Watch Now',
                id: 600,
                name: 'Standing Kickback',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/42+Standing+Kickback.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/42+Standing+Kickback.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 601,
                name: 'Alternating Leg Raises',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/30+Alternating+Leg+Raises.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/30+Alternating+Leg+Raises.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 602,
                name: 'Leg Raises',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/29+Leg+Raises.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/29+Leg+Raises.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 603,
                name: 'Rainbow Kicks',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/20+Rainbow+Kicks.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/20+Rainbow+Kicks.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 604,
                name: 'Bent Knee Glutei Kickback',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/17+Bent+Knee+Glutei+Kickback.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/17+Bent+Knee+Glutei+Kickback.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 605,
                name: 'Straight-Leg Fire Hydrant',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/16+Straight-Leg+Fire+Hydrant.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/16+Straight-Leg+Fire+Hydrant.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 606,
                name: 'Glutei Bridge + Adduction',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/14+Glutei+Bridge+%2B+Adduction.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/14+Glutei+Bridge+%2B+Adduction.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 607,
                name: 'One Leg Glutei Bridge',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/13+One+Leg+Glutei+Bridge.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/13+One+Leg+Glutei+Bridge.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 608,
                name: 'Glutei Bridge',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/12+Glutei+Bridge.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/12+Glutei+Bridge.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 609,
                name: 'Superman',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/10+Superman.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/10+Superman.jpg',
                filename: ''
            },
        ]
    },
    {
        id: 11,
        contents: 3,
        name: {
            tr: 'Legs'
        },
        videos: [{
                duration: 'Watch Now',
                id: 700,
                name: 'Curtsy Lunges',
                videoUrl: 'https://cdn.mobiotv.com/tr/Legs/Curtsy+Lunges.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Legs/Curtsy+Lunges.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 701,
                name: 'Lateral Lunges',
                videoUrl: 'https://cdn.mobiotv.com/tr/Legs/Lateral+Lunges.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Legs/Lateral+Lunges.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 702,
                name: 'Plie Squat',
                videoUrl: 'https://cdn.mobiotv.com/tr/Legs/Plie+Squat.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Legs/Plie+Squat.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 703,
                name: 'Single leg dead lift',
                videoUrl: 'https://cdn.mobiotv.com/tr/Legs/Single+leg+dead+lift.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Legs/Single+leg+dead+lift.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 605,
                name: 'Straight-Leg Fire Hydrant',
                videoUrl: 'https://cdn.mobiotv.com/tr/Glutes/16+Straight-Leg+Fire+Hydrant.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Glutes/16+Straight-Leg+Fire+Hydrant.jpg',
                filename: ''
            },
        ]
    },
    {
        id: 12,
        contents: 3,
        name: {
            tr: 'Mix'
        },
        videos: [{
                duration: 'Watch Now',
                id: 800,
                name: 'Bird Dog',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/11+Bird+Dog.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/11+Bird+Dog.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 801,
                name: 'Kneeling Push-Up',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/18+Kneeling+Push-Up.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/18+Kneeling+Push-Up.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 802,
                name: 'Side Plank',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/22+Side+Plank.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/22+Side+Plank.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 803,
                name: 'T-Plank',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/23+T-Plank.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/23+T-Plank.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 804,
                name: 'Up Down Plank',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/24+Up+Down+Plank.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/24+Up+Down+Plank.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 805,
                name: 'Plank Variation',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/25+Plank+Variation.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/25+Plank+Variation.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 806,
                name: 'R TWIST',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/26+R+TWIST.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/26+R+TWIST.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 808,
                name: 'Crab Toe Touch',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/27+Crab+Toe+Touch.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/27+Crab+Toe+Touch.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 809,
                name: 'Crab Reach',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/28+Crab+Reach.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/28+Crab+Reach.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 810,
                name: 'Jumping Jacks',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/36+Jumping+Jacks.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/36+Jumping+Jacks.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 811,
                name: 'March In Place',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/37+March+In+Place.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/37+March+In+Place.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 812,
                name: 'Run In Place',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/38+Run+In+Place.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/38+Run+In+Place.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 812,
                name: 'Standing Criss Cross',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/40+Standing+Criss+Cross.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/40+Standing+Criss+Cross.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 813,
                name: 'Quick Steps Forwards-Backwards Quick Steps In And Out',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/41+Quick+Steps+Forwards-Backwards+Quick+Steps+In+And+Out.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/41+Quick+Steps+Forwards-Backwards+Quick+Steps+In+And+Out.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 814,
                name: 'Reverse Plank',
                videoUrl: 'https://cdn.mobiotv.com/tr/Mix/8+Reverse+Plank.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Mix/8+Reverse+Plank.jpg',
                filename: ''
            },
        ]
    },
    {
        id: 13,
        contents: 3,
        name: {
            tr: 'Quads'
        },
        videos: [{
                duration: 'Watch Now',
                id: 900,
                name: 'Kneeling Hip Circles',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/19+Kneeling+Hip+Circles.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/19+Kneeling+Hip+Circles.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 901,
                name: 'Forward Lunges',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/32+Forward+Lunge.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/32+Forward+Lunge.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 902,
                name: 'Squat',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/34+Squat.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/34+Squat.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 903,
                name: 'Pulse Squat',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/35+Pulse+Squat.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/35+Pulse+Squat.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 904,
                name: 'Single Leg Death-Lift',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/39+Single+Leg+Death-Lift.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/39+Single+Leg+Death-Lift.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 905,
                name: 'Step Back To High Knee',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/43+Step+Back+To+High+Knee.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/43+Step+Back+To+High+Knee.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 906,
                name: 'Bear Crawl Into Plank Walkout With Legs',
                videoUrl: 'https://cdn.mobiotv.com/tr/Quads/9+Bear+Crawl+Into+Plank+Walkout+With+Legs.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Quads/9+Bear+Crawl+Into+Plank+Walkout+With+Legs.jpg',
                filename: ''
            },
        ]
    },
    {
        id: 14,
        contents: 3,
        name: {
            tr: 'Shoulders'
        },
        videos: [{
                duration: 'Watch Now',
                id: 907,
                name: 'Inch worm',
                videoUrl: 'https://cdn.mobiotv.com/tr/Shoulders/Inch+worm.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Shoulders/Inch+worm.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 908,
                name: 'Plank jacks',
                videoUrl: 'https://cdn.mobiotv.com/tr/Shoulders/Plank+jacks.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Shoulders/Plank+jacks.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 909,
                name: 'Straight arm raises',
                videoUrl: 'https://cdn.mobiotv.com/tr/Shoulders/Straight+arm+raises.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Shoulders/Straight+arm+raises.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 910,
                name: 'Thrusters',
                videoUrl: 'https://cdn.mobiotv.com/tr/Shoulders/Thrusters.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Shoulders/Thrusters.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 911,
                name: 'Upright row',
                videoUrl: 'https://cdn.mobiotv.com/tr/Shoulders/Upright+row.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Shoulders/Upright+row.jpg',
                filename: ''
            }
        ]
    },
    {
        id: 15,
        contents: 3,
        name: {
            tr: 'Triceps'
        },
        videos: [{
                duration: 'Watch Now',
                id: 912,
                name: 'Bent over tricep extension',
                videoUrl: 'https://cdn.mobiotv.com/tr/Triceps/Bent+over+tricep+extension.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Triceps/Bent+over+tricep+extension.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 913,
                name: 'Bilateral tricep kickback',
                videoUrl: 'https://cdn.mobiotv.com/tr/Triceps/Bilateral+tricep+kickback.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Triceps/Bilateral+tricep+kickback.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 914,
                name: 'Chair Tricep Dips',
                videoUrl: 'https://cdn.mobiotv.com/tr/Triceps/Chair+Tricep+Dips.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Triceps/Chair+Tricep+Dips.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 915,
                name: 'Overhead triceps extension',
                videoUrl: 'https://cdn.mobiotv.com/tr/Triceps/Overhead+triceps+extension.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Triceps/Overhead+triceps+extension.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 916,
                name: 'Standing tricep press down',
                videoUrl: 'https://cdn.mobiotv.com/tr/Triceps/Standing+tricep+press+down.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Triceps/Standing+tricep+press+down.jpg',
                filename: ''
            }
        ]
    },
    {
        id: 16,
        contents: 2,
        name: {
            tr: 'Instagram'
        },
        videos: [{
                duration: 'Watch Now',
                id: 917,
                name: 'İNSTAGRAM PROFİLİME KİM BAKTI 2020 (KANITLI VİDEO) ÜCRETSİZ',
                videoUrl: 'https://cdn.mobiotv.com/tr/Instagram/I%CC%87NSTAGRAM+PROFI%CC%87LI%CC%87ME+KI%CC%87M+BAKTI+2020+(KANITLI+VI%CC%87DEO)+U%CC%88CRETSI%CC%87Z.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Instagram/I%CC%87NSTAGRAM+PROFI%CC%87LI%CC%87ME+KI%CC%87M+BAKTI+2020+(KANITLI+VI%CC%87DEO)+U%CC%88CRETSI%CC%87Z.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 918,
                name: 'İnstagram Profilime Kim Baktı Uygulamalarını Denedim! İnstagram Profilime Bakanlar',
                videoUrl: 'https://cdn.mobiotv.com/tr/Instagram/I%CC%87nstagram+Profilime+Kim+Bakt%C4%B1+Uygulamalar%C4%B1n%C4%B1+Denedim!+I%CC%87nstagram+Profilime+Bakanlar.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Instagram/I%CC%87nstagram+Profilime+Kim+Bakt%C4%B1+Uygulamalar%C4%B1n%C4%B1+Denedim!+I%CC%87nstagram+Profilime+Bakanlar.jpg',
                filename: ''
            },
            
            
        ]
    },
    {
        id: 17,
        contents: 2,
        name: {
            tr: 'Tik-Tok'
        },
        videos: [{
                duration: 'Watch Now',
                id: 920,
                name: 'GARANTİLİ TİKTOK KEŞFETE DÜŞME Taktiği! - Tiktok izlenme ve tiktok takipçi keşfet hilesi  - YENİ',
                videoUrl: 'https://cdn.mobiotv.com/tr/Tik-Tok/GARANTI%CC%87LI%CC%87+TI%CC%87KTOK+KES%CC%A7FETE+DU%CC%88S%CC%A7ME+Taktig%CC%86i!+-+Tiktok+izlenme+ve+tiktok+takipc%CC%A7i+kes%CC%A7fet+hilesi++-+YENI%CC%87.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Tik-Tok/GARANTI%CC%87LI%CC%87+TI%CC%87KTOK+KES%CC%A7FETE+DU%CC%88S%CC%A7ME+Taktig%CC%86i!+-+Tiktok+izlenme+ve+tiktok+takipc%CC%A7i+kes%CC%A7fet+hilesi++-+YENI%CC%87.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 921,
                name: 'Sizin Yerinize Popüler Tik-Tok Numaralarını DENEDİK',
                videoUrl: 'https://cdn.mobiotv.com/tr/Tik-Tok/Sizin+Yerinize+Popu%CC%88ler+Tik-Tok+Numaralar%C4%B1n%C4%B1+DENEDI%CC%87K.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Tik-Tok/Sizin+Yerinize+Popu%CC%88ler+Tik-Tok+Numaralar%C4%B1n%C4%B1+DENEDI%CC%87K.jpg',
                filename: ''
            },
            
            
        ]
    },
    {
        id: 19,
        contents: 2,
        name: {
            tr: 'Profilinizi kim kontrol etti?'
        },
        videos: [{
                duration: 'Watch Now',
                id: 922,
                name: 'Facebook Profilime Kim Baktı Ne zaman, Nereye Bakmış 2020',
                videoUrl:'https://cdn.mobiotv.com/tr/Profilinizi+kim+kontrol+etti%3F/Facebook+Profilime+Kim+Bakt%C4%B1+Ne+zaman%2C+Nereye+Bakm%C4%B1s%CC%A7+2020.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Profilinizi+kim+kontrol+etti%3F/Facebook+Profilime+Kim+Bakt%C4%B1+Ne+zaman%2C+Nereye+Bakm%C4%B1s%CC%A7+2020.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 923,
                name: 'İnstagram Profilime Bakanları Bu Uygulamayla BEDAVA Öğrendim[Stalkır Hangi Fotoğrafına Bakmış Öğren]',
                videoUrl: 'https://cdn.mobiotv.com/tr/Profilinizi+kim+kontrol+etti%3F/I%CC%87nstagram+Profilime+Bakanlar%C4%B1+Bu+Uygulamayla+BEDAVA+O%CC%88g%CC%86rendim%5BStalk%C4%B1r+Hangi+Fotog%CC%86raf%C4%B1na+Bakm%C4%B1s%CC%A7+O%CC%88g%CC%86ren%5D.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Profilinizi+kim+kontrol+etti%3F/I%CC%87nstagram+Profilime+Bakanlar%C4%B1+Bu+Uygulamayla+BEDAVA+O%CC%88g%CC%86rendim%5BStalk%C4%B1r+Hangi+Fotog%CC%86raf%C4%B1na+Bakm%C4%B1s%CC%A7+O%CC%88g%CC%86ren%5D.jpg',
                filename: ''
            },
            
            
        ]
    },
    {
        id: 20,
        contents: 10,
        name: {
            tr: 'Futbol'
        },
        videos: [{
                duration: 'Watch Now',
                id: 924,
                name: '10 Futbol Antrenmanı',
                videoUrl:'https://cdn.mobiotv.com/tr/Football/10+FOOTBALL+DRILLS.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/10+FOOTBALL+DRILLS.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 925,
                name: 'Dokunuşu, Top Kontrolünü ve Ayak İşlerini Geliştiren 13 Futbol Antrenmanı',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/13+Football+Drills+To+Improve+Touch+%2C+Ball+Control+and+Footwork.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/13+Football+Drills+To+Improve+Touch+%2C+Ball+Control+and+Footwork.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 926,
                name: 'Hızlı Ayak İşleri İçin 20 Futbol Antrenmanı - 20 Dakikada 1000 Dokunuş',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/20+Fast+Footwork+Football+Drills+-+1000+Touches+In+20+Minutes.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/20+Fast+Footwork+Football+Drills+-+1000+Touches+In+20+Minutes.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 927,
                name: 'Yeni Başlayanlar İçin Futbol Antrenmanları',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/Football+Drills+For+Beginners.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/Football+Drills+For+Beginners.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 928,
                name: 'Çocuklar İçin Futbol Antrenmanları',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/Football+Drills+For+Kids.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/Football+Drills+For+Kids.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 929,
                name: 'Futbolda Daha Agresif Nasıl Olunur - Vücudunuzu Nasıl Kullanmalısınız',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/How+To+Be+MORE+AGGRESSIVE+In+Football+-+How+To+Use+Your+Body.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/How+To+Be+MORE+AGGRESSIVE+In+Football+-+How+To+Use+Your+Body.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 930,
                name: 'Futbolda Ayak İşlerinizi Nasıl Geliştirirsiniz',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/How+to+improve+your+footwork+in+Football.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/How+to+improve+your+footwork+in+Football.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 931,
                name: 'Zayıf Ayağınızı Sadece 1 Günde Nasıl Geliştirirsiniz',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/How+To+Improve+Your+Weak+Foot+In+ONLY+1+Day.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/How+To+Improve+Your+Weak+Foot+In+ONLY+1+Day.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 932,
                name: 'Tek Başına Futbol Nasıl Antrenman Yapılır',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/How+to+practice+football+by+yourself.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/How+to+practice+football+by+yourself.jpg',
                filename: ''
            },
            {
                duration: 'Watch Now',
                id: 933,
                name: 'Tek Başına Pas Antrenmanı Nasıl Yapılır',
                videoUrl: 'https://cdn.mobiotv.com/tr/Football/How+to+PRACTICE+PASSING+by+yourself.mp4',
                desc: '',
                preview: 'https://cdn.mobiotv.com/tr/Football/How+to+PRACTICE+PASSING+by+yourself.jpg',
                filename: ''
            }
        ]
    },
]


// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies_tr.js